/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Feature_Free_DictationInputs */



/**
* | output |
* | --- |
* | "Dictation (speech to text)" |
*
* @param {Plan_Feature_Free_DictationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_feature_free_dictation = /** @type {((inputs?: Plan_Feature_Free_DictationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Feature_Free_DictationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diktat (Sprache zu Text)")
	return /** @type {LocalizedString} */ ("Dictation (speech to text)")
});